export const WebhookEventEnum = {
    create_company: 'Criação de empresa',
    create_employee: 'Criação de funcionário',
}  